export const DEFAULT_MEASUREMENT_SETTINGS = Object.freeze({
  showText: true,
  showArea: true,
  showLength: true,
  showPerimeter: true,
  areaUnit: "AUTO",
  lengthUnit: "AUTO",
  precision: 1,
});
